import useCategoryFeedbackFormHandling from '../useCategoryFeedbackFormHandling';
import { useViewCareTeamFamilyMemberInterviewAnswers } from './useViewCareTeamFamilyMemberInterviewAnswers';
import { CategoryStep } from '../FamilyMemberInterviewWizard/CategoryStep';
import { DietaryHabitsAndHealthUIConfig } from '../../../shared/CategoryStepUIConfig';

const UiConfig = DietaryHabitsAndHealthUIConfig;

export const DietaryHabitsAndHealthCareTeamStep = () => {
	const { application, dietaryHabitsAndHealth, setDietaryHabitsAndHealth } =
		useViewCareTeamFamilyMemberInterviewAnswers();

	const { form, mandatoryQuestionsAndAnswersForm } =
		useCategoryFeedbackFormHandling(
			dietaryHabitsAndHealth,
			setDietaryHabitsAndHealth,
			true
		);

	return (
		<CategoryStep
			uiConfig={UiConfig}
			form={form}
			mandatoryQuestionsAndAnswersForm={mandatoryQuestionsAndAnswersForm}
			answers={application?.userAnswers}
			checkForCareTeamQuestions
		/>
	);
};
